import { ReactNode } from 'react';
import { Shape1, Shape2, Shape3, Shape4 } from './shapes';
import { Container } from './animated-ai.styled';
import { DSScaledColors } from 'styles';

type AnimatedAiProps = {
  color?: keyof DSScaledColors;
  text?: ReactNode;
  size?: string;
  isBright?: boolean;
  animationSpeed?: number;
};

export const AnimatedAi = ({
  text,
  color = 'primary',
  size = '350px',
  isBright = false,
  animationSpeed = 1,
}: AnimatedAiProps) => {
  return (
    <Container
      $color={color}
      $size={size}
      $isBright={isBright}
      $animationSpeed={animationSpeed}
    >
      <Shape1 />
      <Shape2 />
      <Shape3 />
      <Shape4 />

      <div className="central-circle" />
      <div className="text-wrapper">
        {text !== undefined ? text : <p style={{ fontSize: 88 }}>AI</p>}
      </div>
    </Container>
  );
};
